import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, Grid, Stack, Typography } from '@mui/material';
import React from 'react';
import { Formik } from 'formik';
import { TextField } from '@mui/material';
import * as Yup from 'yup';

const validationSchema = Yup.object({
  companyName: Yup.string().required('Company Name is required'),
  companyUEN: Yup.string().required('Company UEN is required'),
  personName: Yup.string().required('Person Name is required'),
  registrationNumber: Yup.string().required('Registration Number is required'),
  concreteType: Yup.string().required('Concrete Type is required'),
  concreteWorkType: Yup.string().required('Concrete Work Type is required'),
  cubeTestResult: Yup.string().required('Concrete Cube Test Result is required')
});

function SgbuildexAddOnDialog({ open, onClose, onConfirm }) {
  const initialValues = {
    companyName: '',
    companyUEN: '',
    personName: '',
    registrationNumber: '',
    concreteType: '',
    concreteWorkType: '',
    cubeTestResult: ''
  };

    const handleSubmitForm = (values) => {
        onConfirm(values)
    };
  return (
    <Dialog maxWidth="sm" fullWidth open={open} onClose={onClose}>
      <DialogTitle mx={3} id="alert-dialog-title">
        Additional Data Concrete Cube Test
      </DialogTitle>
      <DialogContent>
        <DialogContent>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={handleSubmitForm}>
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <Box component="form" onSubmit={handleSubmit} py={1}>
                <Grid container spacing={2}>
                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Project Concrete Supplier Company Name"
                      name="companyName"
                      value={values.companyName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.companyName && Boolean(errors.companyName)}
                      helperText={touched.companyName && errors.companyName}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Project Concrete Supplier Company UEN"
                      name="companyUEN"
                      value={values.companyUEN}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.companyUEN && Boolean(errors.companyUEN)}
                      helperText={touched.companyUEN && errors.companyUEN}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Registered Engineer / Registered Technical Officer Name"
                      name="personName"
                      value={values.personName}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.personName && Boolean(errors.personName)}
                      helperText={touched.personName && errors.personName}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Registered Engineer / Registered Technical Officer Registration Number"
                      name="registrationNumber"
                      value={values.registrationNumber}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.registrationNumber && Boolean(errors.registrationNumber)}
                      helperText={touched.registrationNumber && errors.registrationNumber}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Concrete Type"
                      name="concreteType"
                      value={values.concreteType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.concreteType && Boolean(errors.concreteType)}
                      helperText={touched.concreteType && errors.concreteType}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Concrete Work Type"
                      name="concreteWorkType"
                      value={values.concreteWorkType}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.concreteWorkType && Boolean(errors.concreteWorkType)}
                      helperText={touched.concreteWorkType && errors.concreteWorkType}
                    />
                  </Grid>

                  <Grid size={{ xs: 12, md: 12 }}>
                    <TextField
                      fullWidth
                      label="Concrete Cube Test Result"
                      name="cubeTestResult"
                      multiline
                      rows={3}
                      value={values.cubeTestResult}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      error={touched.cubeTestResult && Boolean(errors.cubeTestResult)}
                      helperText={touched.cubeTestResult && errors.cubeTestResult}
                    />
                  </Grid>
                </Grid>
              </Box>
            )}
          </Formik>
        </DialogContent>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>CLOSE</Button>
        <Button variant="contained" type="submit">
          SUBMIT
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default SgbuildexAddOnDialog;
